import { createFileRoute } from "@tanstack/react-router";

import { SettingsPage } from "@/features/Settings/SettingsPage";
import { TextTab } from "@/features/Settings/tabs/TextTab";

export const Route = createFileRoute("/_auth/settings/$siteId/text")({
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();

  return (
    <SettingsPage
      title="Text"
      description="Manage your SMS provider, compliance, keywords, and send window."
      data-testid="settings-text-page"
    >
      <TextTab siteId={siteId} />
    </SettingsPage>
  );
}
